import React from "react";
import { Globe, Edit } from "lucide-react";
import { AvatarComp } from "../ui/AvatarComp";
import { Link } from "react-router-dom";

function HeroBanner({ exhibitor, onEditProfile, siteSlug, exhibitor_id }) {
  const logo = exhibitor?.logo;
  const name = exhibitor?.name || "Your Company";
  const categoryName = exhibitor?.category_name || "Exhibitor";


  return (
    <section className="relative bg-gray-900 overflow-hidden flex items-center min-h-[12.5rem]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          alt="Banner background"
          className="w-full h-full object-cover"
          src={
            exhibitor?.banner ||
            "https://images.unsplash.com/photo-1540575861501-7cf05a4b125a?q=80&w=2070"
          }
        />
        <div className="absolute inset-0 bg-black/60 md:bg-black/60" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto w-full px-4 md:px-8 py-5 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-8">
        {/* LEFT */}
        <div className="flex items-center gap-3 text-left">
          {/* Logo */}
          <div className="h-16 w-16 md:h-32 md:w-32 flex items-center justify-center rounded-md overflow-hidden bg-white/90 shrink-0">
            {logo ? (
              <img
                src={logo}
                alt={name}
                className="h-full w-auto object-contain"
              />
            ) : (
              <AvatarComp name={name} size="xl" />
            )}
          </div>

          {/* Text */}
          <div className="text-white space-y-1">
            <h1 className="text-sm md:text-2xl font-semibold">{name}</h1>

            <div className="flex flex-col items-start md:gap-1">
              <span className="bg-primary-color text-white text-[10px] px-2 py-0.5 rounded-full font-semibold tracking-wide">
                {categoryName}
              </span>

              <Link
                className="text-gray-300 text-[11px] md:text-sm hover:text-white flex items-center transition-colors"
                to={`/${siteSlug}/exhibitors/profile/${exhibitor_id}`}
              >
                <Globe size={12} className="mr-1" />
                Exhibitor Profile Page
              </Link>
            </div>
          </div>
        </div>

        {/* BUTTON */}
          <Link
            to={`/${siteSlug}/exhibitor/space/exhibitor-profile`}
          className="form-primary-btn text-xs md:text-sm px-4 py-2 h-fit w-fit"
          >
            <Edit size={14} className="mr-2" />
          Edit Exhibitor Profile
          </Link>
      </div>
    </section>
  );
}

export default HeroBanner;
